import { Row, Col } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";

export const ImageWithTextBanner = ({
  customClass = "",
  content,
  buttonTitle,
  buttonLink,
  image,
  imageObjectFit = "cover",
  newPageTab = false,
  buttonClass = "primaryBtn",
  inverted = false,
  bgColor = "bg-black text-white",
}) => {
  return (
    <section className={`${styles.root} ${bgColor} ${customClass}`}>
      <Row className={`m-0 align-items-center ${inverted ? "flex-row-reverse" : ""}`}>
        <Col md={8} className="left-column py-5">
          {content ? (
            <div className="mb-4" dangerouslySetInnerHTML={{ __html: content }} />
          ) : null}
          {buttonLink ? (
            <div>
              <Link href={`${buttonLink}`}>
                {newPageTab ? (
                  <a
                    className={`${buttonClass} no-arrow`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {buttonTitle}
                  </a>
                ) : (
                  <a className={`${buttonClass} no-arrow`}>{buttonTitle}</a>
                )}
              </Link>
            </div>
          ) : null}
        </Col>
        <Col md={4} className="right-column p-0">
          <img
            src={
              image?.url
                ? image.url
                : "/site-assets/placeholders/img-placeholder.jpg"
            }
            alt={image?.alt}
            className="card-img bg-white"
            style={{ objectFit: imageObjectFit }}
          />
        </Col>
      </Row>
    </section>
  );
};

export default ImageWithTextBanner;
